/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

import { getCustomerConsentsAsync } from './DataActionExtension.g';
import { ICustomerConsentVenchi } from './DataServiceEntities.g';

/**
 * GetProfileConsents Input Action
 */
export class GetProfileConsentsInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `GetProfileConsents`;
    public getCacheObjectType = () => 'GetProfileConsents';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * Create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetProfileConsentsInput();
};

/**
 * Call the API and process the results as needed
 */
async function action(input: GetProfileConsentsInput, ctx: Msdyn365.IActionContext): Promise<ICustomerConsentVenchi> {
    const response = await getCustomerConsentsAsync({ callerContext: ctx });
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICustomerConsentVenchi>>action,
    id: 'GetProfileConsents',
    input: createInput
});
